module.exports = __webpack_public_path__ + "static/media/software.4a2bc23a.svg";